export default "__VITE_ASSET__BA4TDn5o__"